class HeroImageSlider {  
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.hero-slider__slide'));
    this.dots = Array.from(el.querySelectorAll('.hero-slider__dot'));
    this.prevBtn = el.querySelector('.hero-slider__arrow--prev');
    this.nextBtn = el.querySelector('.hero-slider__arrow--next');
    this.current = 0;
    this.autoplay = el.dataset.autoplay === 'true';
    this.autoplaySpeed = (parseFloat(el.dataset.autoplaySpeed) || 5) * 1000;
    this.timer = null;
 
    if (this.slides.length <= 1) return;
 
    this.bindEvents();
    if (this.autoplay) this.startAutoplay();
  }
 
  bindEvents() {
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.current + 1);
        this.restartAutoplay();
      });
    }
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.current - 1);
        this.restartAutoplay();
      });
    }
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.slideIndex, 10));
        this.restartAutoplay();
      });
    });
 
    this.el.addEventListener('mouseenter', () => this.stopAutoplay());
    this.el.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });
  }
 
  goTo(index) {
    const total = this.slides.length;
    this.current = (index + total) % total;
 
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.current);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
    });
  }
 
  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => this.goTo(this.current + 1), this.autoplaySpeed);
  }
 
  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }
 
  restartAutoplay() {
    if (this.autoplay) this.startAutoplay();
  }
}
 
function initHeroImageSliders() {
  document.querySelectorAll('.hero-slider').forEach((el) => {
    if (!el.dataset.initialized) {
      el.dataset.initialized = 'true';
      new HeroImageSlider(el);
    }
  });
}
 
document.addEventListener('DOMContentLoaded', initHeroImageSliders);
document.addEventListener('shopify:section:load', initHeroImageSliders);
